import { render, staticRenderFns } from "./1.vue?vue&type=template&id=3e804650&scoped=true&"
var script = {}
import style0 from "./1.vue?vue&type=style&index=0&id=3e804650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e804650",
  null
  
)

export default component.exports